const autocompleteFormActions = {
  accountable: 'Responsáveis',
  helperText: 'Quantidade máxima de responsáveis:',
};

export default autocompleteFormActions;
